import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getInitials = (str: string): string => {
  if (typeof str !== "string" || !str.trim()) return "?";

  return (
    str
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map((word) => word[0])
      .join("")
      .toUpperCase() || "?"
  );
};

export function formatCurrency(
  amount: number,
  opts?: {
    currency?: string;
    locale?: string;
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
    noDecimals?: boolean;
    numberOnly?: boolean;
  },
) {
  const {
    currency = "UZS",
    locale = "uz-UZ",
    minimumFractionDigits,
    maximumFractionDigits,
    noDecimals,
    numberOnly,
  } = opts ?? {};
  const resolvedMinimumFractionDigits = noDecimals ? 0 : minimumFractionDigits;
  const resolvedMaximumFractionDigits = noDecimals ? 0 : maximumFractionDigits;

  if (currency === "UZS") {
    const formatOptions: Intl.NumberFormatOptions = {
      minimumFractionDigits: resolvedMinimumFractionDigits,
      maximumFractionDigits: resolvedMaximumFractionDigits,
    };

    const formatted = new Intl.NumberFormat(locale, formatOptions).format(amount);
    return numberOnly ? formatted : `${formatted} so'm`;
  }

  const formatOptions: Intl.NumberFormatOptions = {
    style: "currency",
    currency,
    minimumFractionDigits: resolvedMinimumFractionDigits,
    maximumFractionDigits: resolvedMaximumFractionDigits,
  };

  return new Intl.NumberFormat(locale, formatOptions).format(amount);
}
